export default __webpack_public_path__ + "static/media/キュラソー.b2bb7296.PNG";